module.exports = __webpack_public_path__ + "static/our-52d7ad9d3a417421373f13270f6f86d8.svg";